<!-- ==========================================
     MAIN HEADER FIGMA - DEUXIÈME BARRE
     ==========================================

     Structure Figma :
     - Logo BeFret à gauche
     - Menus avec icônes: Home, Ship, Contact
     - Boutons Track et Login à droite
     ========================================== -->

<div class="main-header-figma">
  <div class="main-header-container">

    <!-- Logo BeFret à gauche -->
    <div class="logo-section-figma">
      <img
        src="assets/befret_logo.png"
        alt="BeFret Logo"
        class="logo-befret-figma"
        (click)="navigateToHome()">
    </div>

    <!-- Navigation Menu à droite -->
    <nav class="nav-section-figma">

      <!-- Navigation normale (cachée sur mobile) -->
      <div class="desktop-nav-figma">
        <!-- Home avec icône building-library -->
        <button
          class="nav-item-figma"
          (click)="navigateToHome()"
          type="button"
          [attr.aria-label]="'NAVIGATION.HOME' | productionTranslate">
          <img
            src="assets/images/building-library.svg"
            alt="Home icon"
            class="nav-icon-figma">
          <span class="nav-text-figma">{{ 'NAVIGATION.HOME' | productionTranslate }}</span>
        </button>

        <!-- Ship avec icône plane -->
        <button
          class="nav-item-figma"
          (click)="navigateToShip()"
          type="button"
          [attr.aria-label]="'NAVIGATION.SHIP' | productionTranslate">
          <img
            src="assets/images/plane.svg"
            alt="Ship icon"
            class="nav-icon-figma">
          <span class="nav-text-figma">{{ 'NAVIGATION.SHIP' | productionTranslate }}</span>
        </button>

        <!-- Contact avec icône magnifying-glass -->
        <button
          class="nav-item-figma"
          (click)="navigateToContact()"
          type="button"
          [attr.aria-label]="'NAVIGATION.CONTACT' | productionTranslate">
          <img
            src="assets/images/magnifying-glass.svg"
            alt="Contact icon"
            class="nav-icon-figma">
          <span class="nav-text-figma">{{ 'NAVIGATION.CONTACT' | productionTranslate }}</span>
        </button>
      </div>

      <!-- Boutons essentiels (toujours visibles) -->
      <div class="essential-buttons-figma">
        <!-- Dropdown Nos outils -->
        <div class="tools-dropdown-figma dropdown">
          <button
            class="tools-button-figma dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            [attr.aria-label]="'NAVIGATION.OUR_TOOLS' | productionTranslate">
            <span class="tools-text-figma">{{ 'NAVIGATION.OUR_TOOLS' | productionTranslate }}</span>
          </button>

          <ul class="dropdown-menu dropdown-menu-figma">
            <li>
              <a class="dropdown-item dropdown-item-figma" (click)="navigateToTrack()">
                <i class="fas fa-search me-2"></i>
                {{ 'NAVIGATION.MENU.TRACK_PARCEL' | productionTranslate }}
              </a>
            </li>
            <li>
              <a class="dropdown-item dropdown-item-figma" (click)="navigateToPickupPoints()">
                <i class="fas fa-map-marker-alt me-2"></i>
                {{ 'NAVIGATION.MENU.FIND_PICKUP_POINT' | productionTranslate }}
              </a>
            </li>
            <li>
              <a class="dropdown-item dropdown-item-figma" (click)="navigateToPriceCalculator()">
                <i class="fas fa-calculator me-2"></i>
                {{ 'NAVIGATION.MENU.CALCULATE_PRICE' | productionTranslate }}
              </a>
            </li>
            <!-- Virtual Mailbox - visible sur local/dev/acc, caché en prod -->
            <ng-container *ngIf="showVirtualMailbox">
              <li><hr class="dropdown-divider"></li>
              <li>
                <a class="dropdown-item dropdown-item-figma" (click)="navigateToVirtualMailbox()">
                  <i class="fas fa-mailbox me-2"></i>
                  {{ 'NAVIGATION.MENU.VIRTUAL_MAILBOX' | productionTranslate }}
                  <span class="badge bg-warning text-dark ms-2" style="font-size: 0.7rem;">{{ 'NAVIGATION.MENU.NEW_BADGE' | productionTranslate }}</span>
                </a>
              </li>
            </ng-container>
          </ul>
        </div>

        <!-- Bouton Login ou Menu Utilisateur -->
        <div *ngIf="!authService.isLoggedIn(); else userMenu">
          <button
            class="login-button-figma"
            (click)="navigateToLogin()"
            type="button"
            [attr.aria-label]="'NAVIGATION.LOGIN' | productionTranslate">
            <span class="login-text-figma">{{ 'NAVIGATION.LOGIN' | productionTranslate }}</span>
          </button>
        </div>

        <!-- Menu utilisateur connecté -->
        <ng-template #userMenu>
          <div class="user-dropdown-figma dropdown">
            <button
              class="user-button-figma dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false">
              <i class="fas fa-user-circle me-2"></i>
              <span class="user-name-figma">{{ userProfile?.fullname || userProfile?.email || userProfile?.phoneNumber || 'Utilisateur' }}</span>
            </button>
            <ul class="dropdown-menu dropdown-menu-end">
              <li><h6 class="dropdown-header">
                <i class="fas fa-user"></i> {{ userProfile?.fullname || userProfile?.email || userProfile?.phoneNumber }}
              </h6></li>
              <!--
                #1139 — entrée de l'espace client. Le hub « MyBefret » nomme la
                destination (aucun lien du frontoffice n'y menait), les trois
                entrées historiques restent et pointent désormais sur l'URL
                CANONIQUE du portail au lieu des URLs plates : plus de rebond de
                redirection, et c'est bien /portal/… qui s'affiche dans la barre
                d'adresse — ce que le client mémorisera.
              -->
              <li><a class="dropdown-item dropdown-item-mybefret" routerLink="/portal/dashboard">
                <i class="fas fa-th-large"></i> {{ 'NAVIGATION.MENU.MY_BEFRET' | productionTranslate }}
              </a></li>
              <li><hr class="dropdown-divider"></li>
              <li><a class="dropdown-item" routerLink="/portal/shipments">
                <i class="fas fa-history"></i> {{ 'NAVIGATION.MENU.MY_SHIPMENTS' | productionTranslate }}
              </a></li>
              <li><a class="dropdown-item" routerLink="/portal/address-book">
                <i class="fas fa-address-book"></i> {{ 'NAVIGATION.MENU.MY_RECEIVERS' | productionTranslate }}
              </a></li>
              <li><a class="dropdown-item" routerLink="/portal/profile">
                <i class="fas fa-user-edit"></i> {{ 'NAVIGATION.MENU.MY_ACCOUNT' | productionTranslate }}
              </a></li>
              <!-- L'espace VM bascule sous MyBefret au lot 2 (#1140) : le lien
                   reste sur /vm/dashboard, seul le libellé passe par sa clé. -->
              <li *ngIf="showVirtualMailbox && hasVmAccount"><a class="dropdown-item" routerLink="/portal/vm/dashboard">
                <i class="fas fa-mailbox"></i> {{ 'NAVIGATION.MENU.VIRTUAL_MAILBOX' | productionTranslate }}
              </a></li>
              <li><a class="dropdown-item" routerLink="/dashboard" *ngIf="userProfile?.isEmployee">
                <i class="fas fa-chart-bar"></i> {{ 'NAVIGATION.MENU.DASHBOARD' | productionTranslate }}
              </a></li>
              <!-- Envoi Assisté - Section employés -->
              <li *ngIf="userProfile?.isEmployee"><hr class="dropdown-divider"></li>
              <li *ngIf="userProfile?.isEmployee">
                <span class="dropdown-header text-muted" style="font-size: 0.75rem;">
                  <i class="fas fa-headset me-1"></i> {{ 'NAVIGATION.MENU.ASSISTED_SHIPPING' | productionTranslate }}
                </span>
              </li>
              <li *ngIf="userProfile?.isEmployee">
                <a class="dropdown-item" routerLink="/new-shipment" [queryParams]="{mode: 'assisted'}">
                  <i class="fas fa-plus-circle text-success"></i> {{ 'NAVIGATION.MENU.ASSISTED_CREATE_ORDER' | productionTranslate }}
                </a>
              </li>
              <li *ngIf="userProfile?.isEmployee">
                <a class="dropdown-item" routerLink="/envoi-assiste">
                  <i class="fas fa-list-alt text-primary"></i> {{ 'NAVIGATION.MENU.ASSISTED_MANAGE_ORDERS' | productionTranslate }}
                </a>
              </li>
              <li *ngIf="userProfile?.isEmployee">
                <a class="dropdown-item" routerLink="/backoffice">
                  <i class="fas fa-warehouse text-primary"></i> {{ 'NAVIGATION.MENU.LOGISTICS_BACKOFFICE' | productionTranslate }}
                </a>
              </li>
              <li><hr class="dropdown-divider"></li>
              <li><a class="dropdown-item text-danger" (click)="onLogout()" style="cursor: pointer;">
                <i class="fas fa-sign-out-alt"></i> {{ 'NAVIGATION.MENU.LOGOUT' | productionTranslate }}
              </a></li>
            </ul>
          </div>
        </ng-template>
      </div>

      <!-- Bouton Espace employé (tout à droite, discret) -->
      <button
        class="employee-login-btn-figma"
        (click)="navigateToBackofficeLogin()"
        type="button"
        [attr.aria-label]="'NAVIGATION.MENU.EMPLOYEE_SPACE' | productionTranslate">
        <i class="fas fa-building"></i>
      </button>

      <!-- Menu mobile hamburger (visible seulement sur mobile) -->
      <button
        class="mobile-menu-btn-figma"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#mobileMenuFigma"
        [attr.aria-label]="'NAVIGATION.MENU.LABEL' | productionTranslate">
        <i class="fas fa-bars"></i>
      </button>

    </nav>

  </div>

  <!-- Menu mobile offcanvas (comme l'original) -->
  <div class="offcanvas offcanvas-end" tabindex="-1" id="mobileMenuFigma">
    <div class="offcanvas-header" style="background: #22A922; color: white;">
      <div class="offcanvas-title-container">
        <img src="assets/befret_logo.png" alt="BeFret" class="mobile-logo-figma">
      </div>
      <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas"></button>
    </div>
    <div class="offcanvas-body">
      <ul class="nav flex-column">
        <li class="nav-item mb-2">
          <a class="nav-link" (click)="navigateToHome()" data-bs-dismiss="offcanvas">
            <img src="assets/images/building-library.svg" alt="Home" class="mobile-nav-icon">
            {{ 'NAVIGATION.HOME' | productionTranslate }}
          </a>
        </li>
        <li class="nav-item mb-2">
          <a class="nav-link" (click)="navigateToShip()" data-bs-dismiss="offcanvas">
            <img src="assets/images/plane.svg" alt="Ship" class="mobile-nav-icon">
            {{ 'NAVIGATION.SHIP' | productionTranslate }}
          </a>
        </li>
        <li class="nav-item mb-2">
          <a class="nav-link" (click)="navigateToContact()" data-bs-dismiss="offcanvas">
            <img src="assets/images/magnifying-glass.svg" alt="Contact" class="mobile-nav-icon">
            {{ 'NAVIGATION.CONTACT' | productionTranslate }}
          </a>
        </li>

        <!-- Section Nos outils dans le menu mobile -->
        <li class="nav-item mb-2 mobile-section-title">
          <span>{{ 'NAVIGATION.OUR_TOOLS' | productionTranslate }}</span>
        </li>
        <li class="nav-item mb-2">
          <a class="nav-link ps-4" (click)="navigateToTrack()" data-bs-dismiss="offcanvas">
            <i class="fas fa-search text-success"></i>
            {{ 'NAVIGATION.MENU.TRACK_PARCEL' | productionTranslate }}
          </a>
        </li>
        <li class="nav-item mb-2">
          <a class="nav-link ps-4" (click)="navigateToPickupPoints()" data-bs-dismiss="offcanvas">
            <i class="fas fa-map-marker-alt text-success"></i>
            {{ 'NAVIGATION.MENU.FIND_PICKUP_POINT' | productionTranslate }}
          </a>
        </li>
        <li class="nav-item mb-2">
          <a class="nav-link ps-4" (click)="navigateToPriceCalculator()" data-bs-dismiss="offcanvas">
            <i class="fas fa-calculator text-success"></i>
            {{ 'NAVIGATION.MENU.CALCULATE_PRICE' | productionTranslate }}
          </a>
        </li>
        <!-- Virtual Mailbox - visible sur local/dev/acc, caché en prod -->
        <li class="nav-item mb-2" *ngIf="showVirtualMailbox">
          <a class="nav-link ps-4" (click)="navigateToVirtualMailbox()" data-bs-dismiss="offcanvas">
            <i class="fas fa-mailbox text-success"></i>
            {{ 'NAVIGATION.MENU.VIRTUAL_MAILBOX' | productionTranslate }}
            <span class="badge bg-warning text-dark ms-2" style="font-size: 0.7rem;">{{ 'NAVIGATION.MENU.NEW_BADGE' | productionTranslate }}</span>
          </a>
        </li>
        <!-- Espace employé mobile -->
        <li class="nav-item mb-2">
          <a class="nav-link ps-4" (click)="navigateToBackofficeLogin()" data-bs-dismiss="offcanvas">
            <i class="fas fa-building text-success"></i>
            {{ 'NAVIGATION.MENU.EMPLOYEE_SPACE' | productionTranslate }}
          </a>
        </li>
        <!-- Menu connexion/utilisateur mobile -->
        <li class="nav-item mb-2" *ngIf="!authService.isLoggedIn()">
          <a class="nav-link" (click)="navigateToLogin()" data-bs-dismiss="offcanvas">
            <i class="fas fa-sign-in-alt text-success"></i>
            {{ 'NAVIGATION.LOGIN' | productionTranslate }}
          </a>
        </li>
      </ul>

      <!-- Section utilisateur connecté mobile -->
      <div *ngIf="authService.isLoggedIn()" class="user-section-mobile">
        <hr>
        <div class="user-profile-card-mobile">
          <div class="user-info-mobile">
            <i class="fas fa-user-circle user-avatar-mobile"></i>
            <div class="user-details-mobile">
              <div class="user-name-mobile">{{ userProfile?.fullname || userProfile?.email || userProfile?.phoneNumber || 'Utilisateur' }}</div>
              <div class="user-email-mobile">{{ userProfile?.email || userProfile?.phoneNumber }}</div>
            </div>
          </div>
          <div class="user-actions-mobile">
            <!-- #1139 — même structure que le menu desktop (hub MyBefret puis
                 les trois entrées historiques re-pointées sur /portal/…). -->
            <a class="user-action-btn-mobile user-action-btn-mybefret" routerLink="/portal/dashboard" data-bs-dismiss="offcanvas">
              <i class="fas fa-th-large"></i> {{ 'NAVIGATION.MENU.MY_BEFRET' | productionTranslate }}
            </a>
            <a class="user-action-btn-mobile" routerLink="/portal/shipments" data-bs-dismiss="offcanvas">
              <i class="fas fa-history"></i> {{ 'NAVIGATION.MENU.MY_SHIPMENTS' | productionTranslate }}
            </a>
            <a class="user-action-btn-mobile" routerLink="/portal/address-book" data-bs-dismiss="offcanvas">
              <i class="fas fa-address-book"></i> {{ 'NAVIGATION.MENU.MY_RECEIVERS' | productionTranslate }}
            </a>
            <a class="user-action-btn-mobile" routerLink="/portal/profile" data-bs-dismiss="offcanvas">
              <i class="fas fa-user-edit"></i> {{ 'NAVIGATION.MENU.MY_ACCOUNT' | productionTranslate }}
            </a>
            <a class="user-action-btn-mobile" routerLink="/portal/vm/dashboard" *ngIf="showVirtualMailbox && hasVmAccount" data-bs-dismiss="offcanvas">
              <i class="fas fa-mailbox"></i> {{ 'NAVIGATION.MENU.VIRTUAL_MAILBOX' | productionTranslate }}
            </a>
            <a class="user-action-btn-mobile" routerLink="/dashboard" *ngIf="userProfile?.isEmployee" data-bs-dismiss="offcanvas">
              <i class="fas fa-chart-bar"></i> {{ 'NAVIGATION.MENU.DASHBOARD' | productionTranslate }}
            </a>
            <!-- Envoi Assisté - Section employés mobile -->
            <div *ngIf="userProfile?.isEmployee" class="assisted-section-mobile" style="margin-top: 0.5rem; padding-top: 0.5rem; border-top: 1px solid #eee;">
              <span style="font-size: 0.7rem; color: var(--befret-text-muted); display: block; margin-bottom: 0.25rem;">
                <i class="fas fa-headset"></i> {{ 'NAVIGATION.MENU.ASSISTED_SHIPPING' | productionTranslate }}
              </span>
              <a class="user-action-btn-mobile" routerLink="/new-shipment" [queryParams]="{mode: 'assisted'}" data-bs-dismiss="offcanvas">
                <i class="fas fa-plus-circle text-success"></i> {{ 'NAVIGATION.MENU.ASSISTED_CREATE_ORDER' | productionTranslate }}
              </a>
              <a class="user-action-btn-mobile" routerLink="/envoi-assiste" data-bs-dismiss="offcanvas">
                <i class="fas fa-list-alt text-primary"></i> {{ 'NAVIGATION.MENU.ASSISTED_MANAGE_ORDERS' | productionTranslate }}
              </a>
              <a class="user-action-btn-mobile" routerLink="/backoffice" data-bs-dismiss="offcanvas">
                <i class="fas fa-warehouse text-primary"></i> {{ 'NAVIGATION.MENU.LOGISTICS_BACKOFFICE' | productionTranslate }}
              </a>
            </div>
            <button class="user-action-btn-mobile logout-btn-mobile" (click)="onLogout()" data-bs-dismiss="offcanvas">
              <i class="fas fa-sign-out-alt"></i> {{ 'NAVIGATION.MENU.LOGOUT' | productionTranslate }}
            </button>
          </div>
        </div>
      </div>

      <ul class="nav flex-column" *ngIf="!authService.isLoggedIn()">
      </ul>

      <!-- Section langues mobile (comme l'original) -->
      <hr>
      <div class="language-section">
        <label class="form-label language-label">
          <i class="fas fa-globe"></i>
          {{ 'COMMON.NAVIGATION.LANGUAGE' | productionTranslate }}
        </label>
        <div class="language-buttons">
          <button type="button" class="lang-btn"
                  [class.active]="currentLanguage === 'fr'"
                  (click)="setLanguage('fr')"
                  title="Français">🇫🇷</button>
          <button type="button" class="lang-btn"
                  [class.active]="currentLanguage === 'en'"
                  (click)="setLanguage('en')"
                  title="English">🇬🇧</button>
          <button type="button" class="lang-btn"
                  [class.active]="currentLanguage === 'nl'"
                  (click)="setLanguage('nl')"
                  title="Nederlands">🇳🇱</button>
        </div>
      </div>
    </div>
  </div>
</div>